<template>
  <div class="forgot-password">
    <div class="landing-page-wrapper">
      <div class="landing-page-content">
        <div class="forgot-password">
          <h1 class="page-title">
            <div class="content">
              It looks like you don’t have permission to access this page
            </div>
          </h1>
          <p class="page-description text-left">
            Unfortunately, your membership level doesn’t allow you to access this page.<br />
            If you’d like to find out more about how this works and how you can be granted access to this page and others, please get in touch with us.
          </p>
          <div class="landing-page-login-actions">
            <router-link :to="{name: 'contact'}" class="login background-1-100">Contact us</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'no-permissions',
    data () {
      return {}
    },
    methods: {},
    created () {
      document.title = 'No permissions | Clear Assured'
    }
  }
</script>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// NoPermissions.vue?6fc00bfd